module.exports = __webpack_public_path__ + "img/gpic2.png";